import geolib from 'geolib'
import _ from 'lodash'

const PhnomPenh = {
  lat: 11.579524,
  lng: 104.8201469,
}

const icons = {
  userHome: require('../../assets/images/user_home.png'),
  available: require('../../assets/images/available.png'),
  busy: require('../../assets/images/busy.png'),
  outForDelivery: require('../../assets/images/outForDelivery.png'),
  pending: require('../../assets/images/pending.png'),
  restaurant: require('../../assets/images/restaurant.png'),

  requestLocation: require('../../assets/images/requestLocation.png'),
  deliveryLocation: require('../../assets/images/deliveryLocation.png'),

  cluster1: require('../../assets/m1.png'),
  cluster2: require('../../assets/m2.png'),
  cluster3: require('../../assets/m3.png'),
  cluster4: require('../../assets/m4.png'),
  cluster5: require('../../assets/m5.png'),
}

const getIconByStatus = status => {
  switch (status) {
    case 'available': return icons.available
    case 'busy': return icons.outForDelivery
    case 'pending': return icons.pending
    default: return icons.busy
  }
}

const getLabelColor = status => {
  switch (status) {
    case 'available':
      return '#72BA3F'
    case 'busy':
      return '#4A90E2'
    case 'pending':
      return '#F5A623'
    default:
      return '#C02727'
  }
}

const getDistrictPolygon = coordinates => {
  return _.map(coordinates, coordinate => ({
    lat: coordinate[1],
    lng: coordinate[0],
  }))
}

const getCenterPolygon = coordinates => {
  const allCoords = _.map(coordinates, coordinate => ({
    latitude: coordinate[1],
    longitude: coordinate[0],
  }))

  let centerCoord = geolib.getCenter(allCoords)

  centerCoord = {
    lat: Number(centerCoord.latitude),
    lng: Number(centerCoord.longitude),
  }

  return centerCoord
}

const getCenterDriver = drivers => {
  const allDriversCoords = []

  _.map(drivers, driver => {
    if (driver.location) {
      allDriversCoords.push({
        latitude: driver.location.latitude,
        longitude: driver.location.longitude,
      })
    }
  })

  let centerCoord = geolib.getCenter(allDriversCoords)

  if (_.size(centerCoord) > 0) {
    centerCoord = {
      lat: Number(centerCoord.latitude),
      lng: Number(centerCoord.longitude),
    }
  } else {
    centerCoord = PhnomPenh
  }

  return centerCoord
}

const latLng = (google, location) => new google.maps.LatLng(
  location.latitude || location.lat,
  location.longitude || location.lng,
)

export default {
  getCenterDriver,
  getCenterPolygon,
  getDistrictPolygon,
  getLabelColor,
  getIconByStatus,
  icons,
  latLng,
}



// WEBPACK FOOTER //
// ./src/containers/mapView/helpers.js